import { createSlice } from '@reduxjs/toolkit';

import { toastReducer, toastState } from './toast';

/** Component Popup Slice. */
export const componentPopupSlice = createSlice({
  name: 'component_popup',
  initialState: {
    ...toastState,
  },
  reducers: {
    ...toastReducer,
  },
});

/** Component Popup Slice Actions. */
export const componentPopupSliceActions = componentPopupSlice.actions;
